(() => {
  const roots = document.querySelectorAll('[data-id24-test-service]');
  roots.forEach((root) => {
    const radios = root.querySelectorAll('[data-test-variant]');
    const price = root.querySelector('[data-test-price]');
    const total = root.querySelector('[data-test-total]');
    const selection = root.querySelector('[data-test-selection]');
    const form = root.querySelector('#id24-test-product-form');
    const button = root.querySelector('[data-test-submit]');
    const buttonLabel = root.querySelector('[data-test-submit-label]');

    const update = (radio) => {
      if (!radio) return;
      radios.forEach((item) => item.closest('label')?.classList.toggle('is-selected', item === radio));
      if (price) price.textContent = radio.dataset.price || '';
      if (total) total.textContent = radio.dataset.price || '';
      if (selection) selection.textContent = radio.dataset.title || '';
      if (buttonLabel) buttonLabel.textContent = `Commander le test · ${radio.dataset.price || ''}`;
    };

    radios.forEach((radio) => radio.addEventListener('change', () => update(radio)));
    update(root.querySelector('[data-test-variant]:checked'));

    if (form && button) {
      form.addEventListener('submit', (event) => {
        if (!form.checkValidity()) {
          event.preventDefault();
          form.reportValidity();
          return;
        }
        button.disabled = true;
        const label = buttonLabel || button.querySelector('span');
        if (label) label.textContent = 'Ajout en cours…';
      });
    }
  });
})();
